import { Component, Input } from '@angular/core';

export enum QuestionTypeEnum {
	'OFFER' = 'OFFER',
	'INVITE' = 'INVITE',
	'APPLY' = 'APPLY',
	'INVITE_SENT' = 'INVITE_SENT'
}

export interface applicant {
	firstName?: string;
	lastName?: string;
}

@Component({
	selector: 'op-co-app-common-questions',
	templateUrl: './co-app-common-questions.component.html',
	styleUrls: ['./co-app-common-questions.component.scss']
})
export class CoAppCommonQuestionsComponent {
	@Input() questionType: QuestionTypeEnum;
	@Input() data: applicant;

	constructor() {}
}
